import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'gestorfood/fidelidade/1.0.0',
      storage,
      whitelist: ['auth'],
    },
    reducers
  );

  return persistedReducer;
};
